import { GET_SEASON_SUCCESS, GET_ERROR } from "./actionTypes"

const statuslist = {
  idle: "idle",
  process: "process",
  success: "success",
  error: "error",
}

const INIT_STATE = {
  data: null,
  error: null,
  status: statuslist.idle,
}

const Season = (state = INIT_STATE, action) => {
  switch (action.type) {
    case GET_SEASON_SUCCESS:
      return {
        ...state,
        data: action.payload?.data,
        status: statuslist[action.payload.status],
      }
    case GET_ERROR:
      return {
        ...state,
        data: null,
        error: action.payload?.data,
        status: statuslist.error,
      }
    default:
      return state
  }
}

export default Season
